import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-1 mt-1" }
const _hoisted_6 = { class: "d-inline-block w-160" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "col-md-12 mb-2"
}
const _hoisted_10 = { class: "timeline-content" }
const _hoisted_11 = { class: "d-inline-block w-160" }
const _hoisted_12 = {
  key: 1,
  class: "col-md-12 mb-2"
}
const _hoisted_13 = { class: "timeline-content" }
const _hoisted_14 = { class: "d-inline-block w-160" }
const _hoisted_15 = { class: "actif" }
const _hoisted_16 = {
  key: 2,
  class: "col-md-12 mb-2"
}
const _hoisted_17 = { class: "timeline-content" }
const _hoisted_18 = { class: "d-inline-block w-160" }
const _hoisted_19 = { class: "actif" }
const _hoisted_20 = {
  key: 3,
  class: "col-md-12"
}
const _hoisted_21 = { class: "form-group mb-1 mt-1" }
const _hoisted_22 = { class: "d-inline-block w-160" }
const _hoisted_23 = { class: "col-md-12" }
const _hoisted_24 = { class: "form-group mb-1 mt-1" }
const _hoisted_25 = { class: "d-inline-block w-160" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "form-group mb-1 mt-1" }
const _hoisted_28 = { class: "d-inline-block w-160" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 4,
  class: "col-md-12"
}
const _hoisted_31 = { class: "form-group mb-1 mt-1" }
const _hoisted_32 = { class: "d-inline-block w-160" }
const _hoisted_33 = {
  key: 5,
  class: "col-md-12"
}
const _hoisted_34 = { class: "form-group mb-1 mt-1" }
const _hoisted_35 = { class: "d-inline-block w-160" }
const _hoisted_36 = {
  key: 6,
  class: "col-md-12"
}
const _hoisted_37 = { class: "form-group mb-1 mt-1" }
const _hoisted_38 = { class: "d-inline-block w-160" }
const _hoisted_39 = {
  key: 7,
  class: "col-md-12"
}
const _hoisted_40 = { class: "form-group mb-1 mt-1" }
const _hoisted_41 = { class: "d-inline-block w-160" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "row" }
const _hoisted_44 = { class: "col-md-12" }
const _hoisted_45 = { class: "form-group mb-1 mt-1" }
const _hoisted_46 = { class: "d-inline-block w-160" }
const _hoisted_47 = { class: "col-md-12" }
const _hoisted_48 = { class: "form-group mb-1 mt-1" }
const _hoisted_49 = { class: "d-inline-block w-160" }
const _hoisted_50 = { class: "col-md-12" }
const _hoisted_51 = { class: "form-group mb-1 mt-1" }
const _hoisted_52 = { class: "d-inline-block w-160" }
const _hoisted_53 = { class: "col-md-12" }
const _hoisted_54 = { class: "form-group mb-1 mt-1" }
const _hoisted_55 = { class: "d-inline-block w-160" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.i18n.t('tables.income.customer.title')), 1),
            _createTextVNode(": "),
            (_ctx.income?.member_info)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.i18n.t('tables.income.customer.memberClub')), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.i18n.t('tables.income.customer.foreignMember')), 1))
          ])
        ]),
        (_ctx.income?.member_info?.name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, [
                _createElementVNode("b", _hoisted_11, _toDisplayString(_ctx.i18n.t("tables.members.name")), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.income?.member_info?.name), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.income?.member_info?.matricule)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, [
                _createElementVNode("b", _hoisted_14, _toDisplayString(_ctx.i18n.t("tables.members.matricule")), 1),
                _createTextVNode(": "),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.income?.member_info?.matricule), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.income?.member_info?.cin)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("p", _hoisted_17, [
                _createElementVNode("b", _hoisted_18, _toDisplayString(_ctx.i18n.t("tables.members.cin")), 1),
                _createTextVNode(" :"),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.income?.member_info?.cin), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (!_ctx.income?.member_info)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("b", _hoisted_22, _toDisplayString(_ctx.i18n.t('tables.members.name')), 1),
                _createTextVNode(": " + _toDisplayString(_ctx.income?.memberName ?? ''), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("b", _hoisted_25, _toDisplayString(_ctx.i18n.t('tables.income.category_name')), 1),
            _createTextVNode(" : "),
            _createElementVNode("span", null, _toDisplayString(_ctx.income?.service?.category?.name ?? ''), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("b", _hoisted_28, _toDisplayString(_ctx.i18n.t('tables.income.service_name')), 1),
            _createTextVNode(": "),
            _createElementVNode("span", null, _toDisplayString(_ctx.income?.service?.name ?? ''), 1),
            (_ctx.income?.service_type)
              ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                  _createTextVNode(" ("),
                  _createElementVNode("b", null, _toDisplayString(_ctx.income?.service_type ?? ''), 1),
                  _createTextVNode(")")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.income?.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("b", _hoisted_32, _toDisplayString(_ctx.i18n.t('tables.income.description')), 1),
                _createTextVNode(" : " + _toDisplayString(_ctx.income?.description ?? ''), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.income?.total_sessions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("b", _hoisted_35, _toDisplayString(_ctx.i18n.t('tables.income.total_sessions')), 1),
                _createTextVNode(": "),
                _createElementVNode("span", null, _toDisplayString(_ctx.income?.total_sessions ?? ''), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.income?.total_sessions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("b", _hoisted_38, _toDisplayString(_ctx.i18n.t('tables.income.consumed_sessions')), 1),
                _createTextVNode(": "),
                _createElementVNode("span", null, _toDisplayString(_ctx.income?.consumed_sessions ?? 0), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.income?.total_sessions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("b", _hoisted_41, _toDisplayString(_ctx.i18n.t('tables.income.remaining_sessions')), 1),
                _createTextVNode(": "),
                _createElementVNode("span", null, _toDisplayString(_ctx.income?.remaining_sessions ?? 0), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, [
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("b", _hoisted_46, _toDisplayString(_ctx.i18n.t('tables.income.date')), 1),
            _createTextVNode(" : " + _toDisplayString(_ctx.formatDate(_ctx.income?.date)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("b", _hoisted_49, _toDisplayString(_ctx.i18n.t('tables.income.total_amount')), 1),
            _createTextVNode(" : " + _toDisplayString(_ctx.income?.total_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("b", _hoisted_52, _toDisplayString(_ctx.i18n.t('tables.income.total_amount_paid')), 1),
            _createTextVNode(" : " + _toDisplayString(_ctx.income?.total_amount_paid ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("b", _hoisted_55, _toDisplayString(_ctx.i18n.t('tables.income.remaining_amount')), 1),
            _createTextVNode(" : " + _toDisplayString(_ctx.income?.remaining_amount ?? 0) + " " + _toDisplayString(_ctx.i18n.t('symbole.currency.mad')), 1)
          ])
        ])
      ])
    ])
  ]))
}